import { render, staticRenderFns } from "./CustomerDetailsSubscription.vue?vue&type=template&id=4dbc75a2&scoped=true"
import script from "./CustomerDetailsSubscription.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailsSubscription.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDetailsSubscription.vue?vue&type=style&index=0&id=4dbc75a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbc75a2",
  null
  
)

export default component.exports